import { useEffect } from 'react';
import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum';
import { useFeatureFlag, FEATURE_FLAG } from 'lib/LaunchDarkly/useFeatureFlag';
import packageJSON from './../../../package.json';

const DATADOG_ENABLED = process.env.REACT_APP_DATADOG_ENABLED === 'true';
const DATADOG_ENVIRONMENT = process.env.REACT_APP_DATADOG_ENVIRONMENT || 'dev';
const DATADOG_APPLICATION_ID = process.env.REACT_APP_DATADOG_APPLICATION_ID || '';
const DATADOG_CLIENT_TOKEN = process.env.REACT_APP_DATADOG_CLIENT_TOKEN || '';
const DATADOG_SITE = (process.env.REACT_APP_DATADOG_SITE || 'datadoghq.eu') as RumInitConfiguration['site'];
const VERSION = packageJSON.version.toString() || '';

type DatadogInitOptions = {
  readonly enableExperimentalFeatures?: string[];
  readonly sampleRate?: number;
  readonly sessionReplaySampleRate?: number;
  readonly traceSampleRate?: number;
  readonly trackFrustrations?: boolean;
  readonly trackLongTasks?: boolean;
  readonly trackResources?: boolean;
  readonly trackUserInteractions?: boolean;
};

export const DatadogSetup = () => {
  const datadogInitOptions: DatadogInitOptions = useFeatureFlag(FEATURE_FLAG.DATADOG_INIT_OPTIONS);
  const datadogShouldStartSessionReplayRecording = useFeatureFlag(FEATURE_FLAG.DATADOG_START_SESSION_REPLAY_RECORDING);

  useEffect(() => {
    /**
     * Ensure Datadog is only initialized when DATADOG_ENABLED is true.
     * Datadog RUM can be re-initialised with different
     * configuration options, controlled via a Launch Darkly flag.
     */
    if (DATADOG_ENABLED && datadogInitOptions) {
      datadogRum.init({
        applicationId: DATADOG_APPLICATION_ID,
        clientToken: DATADOG_CLIENT_TOKEN,
        site: DATADOG_SITE,
        service: 'talk-fe-connect',
        env: DATADOG_ENVIRONMENT,
        version: VERSION,
        defaultPrivacyLevel: 'mask',
        startSessionReplayRecordingManually: true,
        enableExperimentalFeatures: ['feature_flags'],
        ...datadogInitOptions,
      });

      if (datadogShouldStartSessionReplayRecording) {
        datadogRum.startSessionReplayRecording();
      }
    }
  }, [datadogInitOptions, datadogShouldStartSessionReplayRecording]);

  return null;
};
